import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import "./Cart.css";
import CartItem from "../../Components/CartItems/CartItems";
import Footer from "../../Components/Footer/Footer";
import PriceDetail from "../../Components/PriceDetail/PriceDetail";
import * as actions from "../../Store/Actions/index";
import Breadcrumbs from "react-router-dynamic-breadcrumbs";
import { Link as Router } from "react-router-dom";
import Slider from "react-slick";

class Cart extends Component {
  state = {
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            variableWidth: true,

            touchThreshold: 10,
            swipeToSlide: true,
            touchMove: true,
            centerMode: false,
            initialSlide: 1,
          },
        },
      ],
    },
    routes: {
      "/": "Home",
      "/cart": "Cart",
    },
  };

  AddItemToCart(id) {
    this.props.addItemToCartHandler(id);
  }

  bookDetail = (id,title) => {
    this.props.history.push(`/catalogue/${id}/${title}`);
  };

  render() {
    document.title = "VK Global Publications | Cart";

    return (
      <div>
        <div className="section2 cart-section">
          <div className="box-container">
            <Container>
              <h3 className="  cataloguebreadcrumbs cartbread float-right">
                <Router>
                  <Breadcrumbs mappedRoutes={this.state.routes} />
                </Router>
              </h3>
              <h3 className="cart">Your Cart</h3>

              <Row className="cartRow">
                <Col className="cartbox-container" sm={8}>
                  <div className="boxCart ">
                    <Row className="cartHeading">
                      <Col sm={6}>
                        <h3>PRODUCT</h3>
                      </Col>
                      <Col sm={3}>
                        <h3>QUANTITY</h3>
                      </Col>
                      <Col sm={3}>
                        <h3>AMOUNT</h3>
                      </Col>
                    </Row>
                    {this.props.cartBook.length === 0 ? (
                      <h4 className="cartEmpty">No items in the cart</h4>
                    ) : (
                      <CartItem type="cart" />
                    )}
                  </div>
                </Col>
                <Col className="pricebox-container" sm={4}>
                  <div className="priceBox">
                    <h3>PRICE DETAILS</h3>
                    <PriceDetail
                      route={this.props}
                      cartBook={this.props.cartBook}
                    />
                  </div>
                </Col>
              </Row>
            </Container>
            <div className="recommendSection">
              <Container>
                <h3 className="bookSection">More recommendations for you </h3>
                <Slider {...this.state.settings}>
                  {console.log(this.props.books)}
                  {this.props.books.map((book, index) => (
                    <Row>
                      <Col md={4} className="sectionContainer">
                        <div
                          className="card-wrapper"
                          onClick={() => this.bookDetail(book.book_id,book.title)}
                        >
                          <div className="component-book-details1">
                            <div className="inner-div">
                              <div className="image-container">
                                <img src={book.image} alt="book" />
                              </div>
                              <div className="text-container">
                                <div className="book-name">{book.title}</div>
                                <div className="book-sem">
                                  Class {book.Class}
                                  <br />
                                  Edition {book.edition}
                                </div>
                                <br />
                                <div className="book-price">
                                  Rs {book.price}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ))}
                </Slider>
              </Container>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cartBook: state.book.addedBooks,
    quantity: state.book.quantity,
    newQuantity: state.book.newQuantity,
    bookAvailable: state.book.available,
    books: state.book.books,
  };
};

const mapDispatchtoProps = (dispatch) => {
  return {
    addItemToCartHandler: (id) => dispatch(actions.addItemToCart(id)),
  };
};

export default connect(mapStateToProps, mapDispatchtoProps)(Cart);
